<script setup lang="ts">
import { ChevronDownIcon } from '@heroicons/vue/24/outline';

defineProps<{
  title: string;
  subtitle: string;
  showBack: boolean;
  ready: boolean;
  submitted: boolean;
  submitting: boolean;
}>();

const emit = defineEmits<{
  back: [];
  submit: [];
  'open-tools': [];
  'open-details': [];
}>();
</script>

<template>
  <div class="flex flex-none flex-col border-b border-gray-200 bg-white" data-test="mobile-top-bar">
    <div class="flex items-center gap-2.5 px-3 py-2.5">
      <button
        v-if="showBack"
        type="button"
        aria-label="Back"
        data-test="btn-mobile-back"
        class="flex h-9 w-9 flex-none items-center justify-center rounded-lg border border-gray-200 text-gray-700 hover:bg-gray-50"
        @click="emit('back')"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 4 6 10l6 6" />
        </svg>
      </button>
      <div class="min-w-0 flex-1">
        <div class="truncate text-sm font-semibold text-gray-900">{{ title }}</div>
        <div class="text-[11.5px] text-gray-500">{{ subtitle }}</div>
      </div>
      <button
        type="button"
        :disabled="!ready || submitted || submitting"
        data-test="btn-mobile-submit"
        class="flex h-9 flex-none items-center rounded-lg px-3 text-[12.5px] font-semibold"
        :class="
          ready && !submitted && !submitting
            ? 'cursor-pointer bg-indigo-600 text-white hover:bg-indigo-700'
            : 'cursor-not-allowed bg-gray-100 text-gray-400'
        "
        @click="emit('submit')"
      >
        {{ submitted ? 'Submitted' : submitting ? 'Submitting…' : 'Submit' }}
      </button>
      <button
        type="button"
        aria-label="Tools and reference"
        data-test="btn-mobile-tools"
        class="flex h-9 w-9 flex-none items-center justify-center rounded-lg border border-gray-200 text-gray-700 hover:bg-gray-50"
        @click="emit('open-tools')"
      >
        <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
          <rect x="3" y="3" width="7.5" height="7.5" rx="2" />
          <rect x="13.5" y="3" width="7.5" height="7.5" rx="2" />
          <rect x="3" y="13.5" width="7.5" height="7.5" rx="2" />
          <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="2" />
        </svg>
      </button>
    </div>

    <div
      class="flex items-center border-t border-gray-100 px-3 py-1.5"
      data-test="mobile-top-bar-details-row"
    >
      <button
        type="button"
        data-test="btn-mobile-case-details"
        class="ml-auto inline-flex items-center gap-1 text-[11.5px] font-medium text-indigo-600 hover:text-indigo-700"
        @click="emit('open-details')"
      >
        Details
        <ChevronDownIcon class="size-3.5" />
      </button>
    </div>
  </div>
</template>
